import React, { useState } from 'react';
import { Modal, Spin, message } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import { getServiceQrcode } from '../../api/qrcode';
import './NoPermission.css';

const NoPermission = () => {
    const [modalVisible, setModalVisible] = useState(false);
    const [qrcodeUrl, setQrcodeUrl] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleServiceClick = async () => {
        setModalVisible(true);
        setLoading(true);
        setError('');
        setQrcodeUrl('');

        try {
            const res = await getServiceQrcode();
            if (res.code === 0 && res.data) {
                setQrcodeUrl(res.data);
            } else {
                setError(res.message || '获取二维码失败');
                message.error(res.message || '获取二维码失败');
            }
        } catch (err) {
            const errorMsg = err.message || '获取二维码失败，请稍后重试';
            setError(errorMsg);
            message.error(errorMsg);
        } finally {
            setLoading(false);
        }
    };

    const handleModalClose = () => {
        setModalVisible(false);
        setQrcodeUrl('');
        setError('');
    };

    return (
        <div className="no-permission-container">
            <div className="no-permission-content">
                <div className="no-permission-icon">
                    <CloseCircleOutlined style={{ fontSize: '80px', color: '#d32f2f' }} />
                </div>

                <div className="no-permission-message">
                    暂无登录权限，如需开启权限，请联系
                    <span className="service-link" onClick={handleServiceClick}>
                        《优量》客服
                    </span>
                    咨询！
                </div>
            </div>

            <Modal
                title="联系客服"
                open={modalVisible}
                onCancel={handleModalClose}
                footer={null}
                width={400}
                className="qrcode-modal"
            >
                {loading && (
                    <div className="qrcode-loading">
                        <Spin size="large" tip="加载中..." />
                    </div>
                )}

                {!loading && error && (
                    <div className="qrcode-error">
                        {error}
                    </div>
                )}

                {!loading && !error && qrcodeUrl && (
                    <div>
                        <img
                            src={qrcodeUrl}
                            alt="客服二维码"
                            className="qrcode-image"
                            onError={() => {
                                setError('二维码加载失败');
                                message.error('二维码加载失败');
                            }}
                        />
                        <p style={{ marginTop: '20px', color: '#666', fontSize: '14px' }}>
                            扫描二维码联系客服
                        </p>
                    </div>
                )}
            </Modal>
        </div>
    );
};

export default NoPermission;
